// extracted by mini-css-extract-plugin
export default {"input":"wZUg1O2vBGlKFa5rjRTON"};